// Personal settings: the colour theme for this browser. Ogma is light (off-white) unless a person chooses dark, or
// to follow the device. Saved in this browser only; storage can be blocked, so every read and write is wrapped.
export type ThemePref = "light" | "dark" | "device";

const KEY = "ogma-theme";

export function readThemePref(): ThemePref {
  try {
    const v = window.localStorage.getItem(KEY);
    return v === "dark" || v === "device" ? v : "light";
  } catch {
    return "light";
  }
}

/** Sets data-theme on the page; the dark tokens in styles.css apply to "dark", and to "device" when the device is dark. */
export function applyThemePref(pref: ThemePref, doc: Document = document): void {
  if (pref === "light") doc.documentElement.removeAttribute("data-theme");
  else doc.documentElement.setAttribute("data-theme", pref);
}

/** Applies and remembers the choice. Returns false when this browser blocks saving (it applies until the page closes). */
export function saveThemePref(pref: ThemePref): boolean {
  applyThemePref(pref);
  try {
    if (pref === "light") window.localStorage.removeItem(KEY);
    else window.localStorage.setItem(KEY, pref);
    return true;
  } catch {
    return false;
  }
}
